import ProductDisplayInRow from '@/src/components/DragRowDisplay/ProductDisplayInRowShort';
import { get } from 'lodash';
import React from 'react';
import DeleteButton from 'src/components/Buttons/DeleteButton';
import ProductSelection from 'src/constrains/ProductSelectionNoPagination/GeneralSalesChannelProductSelection';
import { useSalesChannelWithSisterProductSelectionUuid } from 'src/hooks/useSalesChannelWithSisterProductSelectionUuid';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';
const Product = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data, onChange, isPrimary } = props;
  const [visible, setVisible] = React.useState(false);
  const onCancel = () => {
    setVisible(false);
  };
  const onAdd = () => {
    setVisible(true);
  };
  const onOk = (products = []) => {
    if (products.length > 0) {
      const _pWithDraggableId = products.map((i) => {
        const { uuid } = i;
        return { ...i, draggableId: uuid };
      });
      const prod = _pWithDraggableId[0];
      if (onChange) onChange({ salesChannelProduct: prod });
      onCancel();
    }
  };
  const handleOnDelete = () => {
    if (onChange) onChange({ salesChannelProduct: null });
  };
  const sku = get(data, '0.sku');
  const name = get(data, '0.productName');
  const thumbnailUrl = get(data, '0.thumbnailUrl');
  const salesChannelUuid = useSalesChannelWithSisterProductSelectionUuid();

  //
  return (
    <React.Fragment>
      {visible && (
        <ProductSelection
          visible={visible}
          onCancel={onCancel}
          onOk={onOk}
          selectedProducts={data || []}
          disabledProducts={[]}
          type={'radio'}
          salesChannelUuid={salesChannelUuid}
        />
      )}
      <div className={css.addProduct}>
        {data ? (
          <div className={css.productDisplay}>
            <ProductDisplayInRow sku={sku} name={name} img={thumbnailUrl} />
            {isPrimary && (
              <DeleteButton
                //disable={disableDelete}
                onClick={handleOnDelete}
                className={css.deleteIcon}
              />
            )}
          </div>
        ) : (
          isPrimary && (
            <div className={css.select} onClick={onAdd}>
              + {getI18n('general.selectProduct')}
            </div>
          )
        )}
      </div>
    </React.Fragment>
  );
};
export default Product;
